import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { NotificationsSettingsForm } from 'src/components/notifications';
import { useScreenInfo } from 'src/hooks/common';

export const NotificationsSettingsPage: React.FC = () => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return <NotificationsSettingsForm />;
  }

  return (
    <DetailPageLayout titleContent="Notifications">
      <NotificationsSettingsForm />
    </DetailPageLayout>
  );
};
